export var hasUserLoans = function (merchantResponseData) {
    return merchantResponseData.data.loans.length > 0;
};
